// 全局环境配置（审计修复 #14：第三方地址不再硬编码在页面里）
// 可通过 .env / 构建环境变量覆盖：VUE_APP_WS_URL
export const WS_URL = process.env.VUE_APP_WS_URL || 'wss://ws.nuanzhi.vip'

/**
 * 管理端菜单权限清单（2026-10-09 重设计）
 * --------------------------------------------------------------
 * 角色模型：
 *   · 超级管理员（role=9）      → 全部菜单 / 全平台数据 / 资金敏感操作
 *   · 机构管理员（role=1）      → 除 superOnly 外的菜单 / 仅本机构数据（后端按 org 过滤）
 *   · 公会创作者·会长（leader） → 仅 guildVisible 菜单（公会管理）/ 仅自己公会（后端按 leader 过滤）
 * 每项说明：
 *   · group：侧边栏分组标题（按业务域归类，运营一眼定位）
 *   · desc ：一句话功能说明（菜单项副标题）
 *   · superOnly / guildVisible：可见性声明
 * 新增页面时在此声明一次即可，侧边栏与路由守卫共用这份定义。
 */
export const MENU = [
  // —— 运营总览 ——
  { path: '/dashboard', icon: 'el-icon-s-home', title: '运营总览', desc: '用户/收入/房间核心数据大盘', group: '运营总览' },
  { path: '/user-distribution', icon: 'el-icon-map-location', title: '用户分布与质量', desc: '地区分布地图·优质用户分层', group: '运营总览' },
  { path: '/revenue-guide', icon: 'el-icon-guide', title: '收益规则指引', desc: '计费点/收益来源/分成公式', group: '运营总览', guildVisible: true },
  { path: '/feature-analytics', icon: 'el-icon-data-analysis', title: '功能点看板', desc: '用户功能体验意向分析', group: '运营总览', superOnly: true },

  // —— 用户与社交 ——
  { path: '/users', icon: 'el-icon-user', title: '用户管理', desc: '查询用户·封禁·调整资产', group: '用户与社交' },
  { path: '/rooms', icon: 'el-icon-chat-dot-round', title: '房间管理', desc: '语音房/直播间状态管理', group: '用户与社交' },
  { path: '/guilds', icon: 'el-icon-s-flag', title: '公会管理', desc: '公会·成员·分成比例管理', group: '用户与社交', guildVisible: true },
  { path: '/organizations', icon: 'el-icon-s-shop', title: '机构管理', desc: '合作机构入驻与账号', group: '用户与社交', superOnly: true },

  // —— 交易与资金 ——
  { path: '/recharge', icon: 'el-icon-wallet', title: '充值记录', desc: '平台充值流水查询', group: '交易与资金' },
  { path: '/mall', icon: 'el-icon-shopping-bag-1', title: '赠送/消费记录', desc: '礼物赠送与消费明细', group: '交易与资金' },
  { path: '/withdraw', icon: 'el-icon-money', title: '提现审核', desc: '提现申请审核与打款', group: '交易与资金', superOnly: true },
  { path: '/finance', icon: 'el-icon-s-marketing', title: '财务报表', desc: '收入/提现/费用汇总', group: '交易与资金' },
  { path: '/revenue-board', icon: 'el-icon-date', title: '收益日看板', desc: '平台/机构/公会日营收与亏损预警', group: '交易与资金', guildVisible: true },

  // —— 增值与营销 ——
  { path: '/gifts', icon: 'el-icon-present', title: '礼物管理', desc: '礼物上架与价格配置', group: '增值与营销', superOnly: true },
  { path: '/decorations', icon: 'el-icon-brush', title: '装扮管理', desc: '头像框/入场特效等商品', group: '增值与营销', superOnly: true },
  { path: '/vip', icon: 'el-icon-medal', title: 'VIP管理', desc: '贵族等级与特权配置', group: '增值与营销', superOnly: true },
  { path: '/rank', icon: 'el-icon-s-data', title: '榜单管理', desc: '各榜单展示配置', group: '增值与营销' },
  { path: '/org-rewards', icon: 'el-icon-thumb', title: '推广奖励设置', desc: '机构推广返奖规则', group: '增值与营销', superOnly: true },
  { path: '/org-reward-logs', icon: 'el-icon-document', title: '推广奖励明细', desc: '奖励发放记录查询', group: '增值与营销', superOnly: true },
  { path: '/assist-dashboard', icon: 'el-icon-data-line', title: '助力成本看板', desc: '预算消耗/ROI/日报', group: '增值与营销' },
  { path: '/assist-activities', icon: 'el-icon-magic-stick', title: '助力活动配置', desc: '活动/阶梯系数/预算启停', group: '增值与营销' },
  { path: '/assist-records', icon: 'el-icon-tickets', title: '助力记录', desc: '助力单明细与风控复核', group: '增值与营销' },
  { path: '/assist-blacklist', icon: 'el-icon-remove-outline', title: '助力黑名单', desc: '设备/openid/IP 风控名单', group: '增值与营销' },

  // —— 系统设置 ——
  {
    title: '系统设置', icon: 'el-icon-setting', desc: '平台基础参数配置', group: '系统设置', superOnly: true,
    children: [
      { path: '/settings/basic', title: '基本设置', desc: '站点名称/客服等' },
      { path: '/settings/exchange', title: '兑换设置', desc: '钻石兑换比例' },
      { path: '/settings/agreements', title: '协议管理', desc: '用户协议/隐私政策' },
      { path: '/settings/payment', title: '支付设置', desc: '支付通道参数' },
    ],
  },
  { path: '/trtc-accounts', icon: 'el-icon-video-camera', title: 'TRTC账号', desc: '直播线路账号池/故障切换', group: '系统设置', superOnly: true },
  { path: '/audit-logs', icon: 'el-icon-s-order', title: '审计日志', desc: '后台访问与操作留痕', group: '系统设置', superOnly: true },
]

/** 超管专属路由集合（路由守卫用） */
export const SUPER_PATHS = MENU.reduce((set, m) => {
  if (m.superOnly && m.path) set.add(m.path)
  if (m.children) m.children.forEach(c => { if (c.path && m.superOnly) set.add(c.path) })
  return set
}, new Set())

/** 公会会长可见路由集合（路由守卫用：会长仅限公会管理） */
export const GUILD_PATHS = MENU.reduce((set, m) => {
  if (m.guildVisible && m.path) set.add(m.path)
  return set
}, new Set())
